/**
 * Created by sy on 2018/9/18.
 */
export default {
  getBannerList: (state) => state.getBannerList,
};
